import {
  buildDonationsInWindow,
  MOCK_DONATION_LATEST_MS,
  toFinancialYear,
} from './donation-fixtures'
import type { MockPersona } from './types'

const DEREK_JOIN_MS = Date.UTC(2026, 3, 29, 10, 30, 0)
/** Donations spread from join date up to mock “today”. */
const DEREK_DONATIONS_END_MS = MOCK_DONATION_LATEST_MS

const derekDonations = buildDonationsInWindow({
  period: '2026-2027',
  count: 16,
  startMs: DEREK_JOIN_MS,
  endMs: DEREK_DONATIONS_END_MS,
  idPrefix: 'don-derek-2026-2027',
  sourceLabel: 'JustGiving',
})

/** Joined 29 Apr 2026 via JustGiving, donations in current year, no issued statement yet. */
export const derekDomino: MockPersona = {
  id: 'derek-domino',
  label: 'Derek Domino',
  description: 'Active donor since Apr 2026; no annual statement issued yet',
  defaultPlan: 'free',
  me: {
    landingPage: 100,
    emailAddress: 'derek.domino@example.com',
    details: {
      firstname: 'Derek',
      lastname: 'Domino',
      addressLine1: '8 Station Road',
      addressLine2: '',
      city: 'Manchester',
      postcode: 'M1 2AB',
      county: 'Greater Manchester',
      country: 'United Kingdom',
    },
    accounts: [
      {
        type: 'emailAddress',
        id: 'derek.domino@example.com',
        created: '2026-04-29T10:30:00.000Z',
        updated: '2026-04-29T10:30:00.000Z',
      },
      {
        type: 'card',
        id: 'fidel.derek-domino-mock-card',
        reference: '4242',
        firstNumbers: '424242',
        scheme: 'visa',
        created: '2026-04-29T10:30:00.000Z',
        updated: '2026-04-29T10:30:00.000Z',
        expDate: '2099-08-25T23:59:59.999Z',
        countryCode: 'GBR',
        accountId: 'derek-domino-card-01',
        cardholderName: 'Derek Domino',
        meta: {},
      },
    ],
  },
  donations: {
    financialYears: [toFinancialYear('2026-2027', derekDonations)],
  },
  statements: { statements: [] },
  authorisation: {
    authorised: '2026-04-29T10:30:00.000Z',
    created: '2026-04-29T10:30:00.000Z',
    platform: 'JustGiving',
    expiry: '2027-04-05T23:59:59.999Z',
    canBeExtended: false,
  },
}
